// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"NewsLetter_newsletter__9kmGr","email_box":"NewsLetter_email_box__LqlSj","title":"NewsLetter_title__NI9F_"};